import { Roles } from '../../../constants/authRoles';
import PermissionsEnum from '../../../constants/permissions';
import { arraysHasCommonElements } from '../../../utils/arrays';
import { IStoreUrlOutput } from 'services/api/store';
import { PageTypeEnum } from 'constants/pageType';

type Permissions = {
  [key in PermissionsEnum]: string;
};

// interface IAccessOptions {
//   userRoles?: Roles[];
//   userPermissionsMap?: Permissions;
//   requiredRoles?: Roles[];
//   requiredPermission?: PermissionsEnum;
// }

// export const userHasAccess = (options: IAccessOptions) => {
//   const { userRoles, userPermissionsMap, requiredRoles, requiredPermission } =
//     options;

//   let roleAccess = true;
//   let permissionsAccess = true;

//   if (userRoles && requiredRoles) {
//     roleAccess = arraysHasCommonElements(userRoles, requiredRoles);
//   }

//   if (requiredPermission && userPermissionsMap) {
//     permissionsAccess = requiredPermission in userPermissionsMap;
//   }

//   return roleAccess && permissionsAccess;
// };

interface IAccessOptions {
  isLogin: boolean;
  userPermissionsMap: Permissions | null;
  requiredLogin: boolean | null;
  requiredPermission: PermissionsEnum | null;
  settingsMap: IStoreUrlOutput['data']['settings'] | null;
  pageType: PageTypeEnum | null;
}

export const userHasAccess = (options: IAccessOptions) => {
  const {
    isLogin,
    userPermissionsMap,
    requiredLogin,
    requiredPermission,
    pageType,
    settingsMap,
  } = options;

  let authAccess = requiredLogin === null ? true : isLogin === requiredLogin;
  let permissionsAccess = true;

  let settingsAccess = true;
  /* if (pageType && settingsMap) {
    if (
      pageType === PageTypeEnum.Shop &&
      settingsMap['cellock.general.shop'] !== '1'
    ) {
      settingsAccess = false;
    }
  }*/

  if (requiredPermission && userPermissionsMap) {
    permissionsAccess = requiredPermission in userPermissionsMap;
  }

  return authAccess && permissionsAccess && settingsAccess;
};
